/* script */
//
//
//
//
//
//
//
//
//

// Components
import ReportExportModal from 'shared/ui/components/modals/ReportExportModal.vue';

/**
 * @typedef {object} ReportCardProps
 * @prop {string} name
 * @prop {string} [icon]
 * @prop {'alt-1'|'alt-2'|'alt-3'|'alt-4'} [iconStyle]
 * @prop {boolean} [showPlatforms]
 * @prop {boolean} [showPaxFields]
 * @prop {boolean} [includeFpExtId]
 * @prop {boolean} [hideDates]
 */

/**
 * @vue-prop {string} eventId the workspace ID
 * @vue-prop {string} name the name of the report to export
 * @vue-prop {string} icon the icon to use for the report
 * @vue-prop {alt-1|alt-2|alt-3|alt-4} iconStyle the style of the icon (colors)
 *
 * @category ui.components.analytics
 * @exports ReportCard
 * @component
 */
const __vue_script__ = {
    name: 'ReportCard',

    /** @type {ReportCardProps & Record<string,unknown>} */
    props: {
        event: {
            type: Object,
            required: true
        },

        name: {
            type: String,
            required: true
        },

        icon: {
            type: String,
            default: 'list'
        },

        iconStyle: {
            type: String,
            default: 'alt-1'
        },

        showPlatforms: {
            type: Boolean,
            default: true,
        },

        showPaxFields: {
            type: Boolean,
            default: true
        },

        includeFpExtId: {
            type: Boolean,
            default: false
        },

        hideDates: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        const titleKey = `analytics.reports.${this.name}.title`;
        const shortDescriptionKey = `analytics.reports.${this.name}.short_description`;
        const longDescriptionKey = `analytics.reports.${this.name}.long_description`;
        const title = this.$te(titleKey) ? this.$t(titleKey) : this.$utils.strings.humanize(this.name, true);
        const shortDescription = this.$te(shortDescriptionKey) ? this.$t(shortDescriptionKey) : '';
        const longDescription = this.$te(longDescriptionKey) ? this.$t(longDescriptionKey) : '';

        return {
            title, shortDescription, longDescription,
        };
    },

    methods: {
        openExportModal() {
            this.$modal.show(ReportExportModal, {
                title: this.title,
                longDescription: this.longDescription,
                shortDescription: this.shortDescription,
                event: this.event,
                reportName: this.name,
                icon: this.icon,
                iconStyle: this.iconStyle,
                showPlatforms: this.showPlatforms,
                showPaxFields: this.showPaxFields,
                hideDates: this.hideDates,
                includeFpExtId: this.includeFpExtId,
            }, {
                classes: 'small',
                height: 'auto'
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-card",on:{"click":_vm.openExportModal}},[_c('h3',[_c('div',{staticClass:"icon-wrapper",class:_vm.iconStyle},[_c('i',{class:("ic-" + _vm.icon)})]),_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.shortDescription))])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ReportCard.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__